import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { password, username, userPassMap } from '../internal.js'

const credentialTypes = [username, password] as const

export const warwDocumentTypes = [
  'signed-bol',
  'proof-of-delivery',
  'invoice',
  'other',
] as const satisfies readonly DocumentType[]

export type warwCredType = (typeof credentialTypes)[number]
export const warw: CarrierDef<warwCredType> = {
  name: 'White Arrow',
  scac: 'warw',
  credentialTypes,
  legacyCredMap: [...userPassMap],
  engineLayers: ['rating', 'pickup', 'documents'],
  documentTypes: warwDocumentTypes,
}
